import "./LessonsList.css";

import { Course, Lesson, User } from "../../../model/model";
import { RootState, useAppDispatch, useAppSelector } from "../../../store";

import { CUser } from "../../../model/classes/CUser";
import { klassi } from "../../../utils/utils";
import { lessonActions } from "../../../store/slices/lessonSlice";
import { updateAppUserThunk } from "../../../store/slices/userThunks";

interface Props {
  user: User;
  course: Course;
}

export default function LessonsList(props: Props) {
  const { user, course } = props;
  const dispatch = useAppDispatch();
  const selectedLesson = useAppSelector(
    (state: RootState) => state.lesson.lesson
  );
  const layout = useAppSelector((state: RootState) => state.lesson.layout);

  const onLessonClick = (lesson: Lesson) => {
    dispatch(lessonActions.setLesson(lesson));
  };

  const onCompleteClick = (lesson: Lesson) => {
    const cuser = new CUser(user);
    cuser.completeLesson(lesson.uid);
    dispatch(updateAppUserThunk(cuser.json));
  };

  const listClass = klassi({ active: layout.list }, "lessons-list");
  const allDone = user.completed.length === course.lessons.length;

  return (
    <div className={listClass}>
      <div className="lessons-list-title">Lessons</div>
      <ul>
        {course.lessons.map((lesson, idx) => {
          const selected = selectedLesson?.uid === lesson.uid;
          const completed = user.completed.some((uid) => uid === lesson.uid);
          const progress = user.progress === idx;
          const klass = klassi(
            {
              selected,
              completed,
              progress,
              disabled: !selected && !completed && !progress,
            },
            "lesson-item"
          );
          return (
            <li
              key={lesson.uid}
              className={klass}
              onClick={() =>
                progress || completed ? onLessonClick(lesson) : null
              }
            >
              <div className="lesson-title">{lesson.name}</div>
              {progress && !allDone && (
                <div className="lesson-button">
                  <button
                    className="loa-button"
                    onClick={() => onCompleteClick(lesson)}
                  >
                    Complete Lesson
                  </button>
                </div>
              )}
            </li>
          );
        })}
        {allDone && (
          <li className="lesson-item all-done" key="all-done">
            All Done!
          </li>
        )}
      </ul>
    </div>
  );
}
